import { Translation } from '../types';

export const et: Translation = {
  common: {
    loading: 'Laadimine...',
    error: 'Viga',
    cancel: 'Tühista',
    save: 'Salvesta',
    close: 'Sulge',
    search: 'Otsi',
    reload: 'Laadi uuesti',
    logout: 'Logi välja',
    dashboard: 'Töölaud',
    products: 'Tooted',
    settings: 'Seaded',
    language: 'Keel',
    businessHours: 'Tööaeg',
    back: 'Tagasi',
    selectAll: 'Vali kõik',
    deselectAll: 'Tühista valik',
    success: 'Õnnestus',
    selected: 'Valitud',
    confirm: 'Kinnita',
    required: 'Kohustuslik',
    requiredMarker: '*',
    previous: 'Eelmine',
    next: 'Järgmine',
    allRightsReserved: 'Kõik õigused kaitstud.',
  },
  auth: {
    login: 'Logi sisse',
    email: 'E-posti aadress',
    password: 'Parool',
    loginButton: 'Logi sisse',
    loggingIn: 'Sisselogimine...',
    loginSuccess: 'Sisselogimine õnnestus',
    loginError: 'E-post või parool on vale',
    invalidEmail: 'Palun sisestage kehtiv e-posti aadress',
    requiredFields: 'Palun sisestage e-post ja parool',
    demoAccount: 'Demokonto:',
    loginDescription: 'Sisestage oma konto andmed sisselogimiseks',
    welcomeMessage: 'Tere tulemast äritellimuste süsteemi',
    // Registration
    register: 'Registreeri',
    createAccount: 'Loo konto',
    confirmPassword: 'Kinnita parool',
    passwordRequirements: 'Parool peab olema vähemalt 8 tähemärki pikk ning sisaldama suur- ja väiketähti, numbrit ja erimärki',
    passwordsDoNotMatch: 'Paroolid ei ühti',
    registrationSuccess: 'Registreerimine õnnestus',
    registrationDescription: 'Registreerige ärikonto',
    alreadyHaveAccount: 'Kas teil on juba konto?',
    signIn: 'Logi sisse',
    dontHaveAccount: "Puudub konto?",
    creatingAccount: 'Konto loomine...',
    registrationNote: 'Märkus:',
    registrationNotePoints: {
      erpLinking: 'Kui teil on olemasolev ärikonto, seostatakse teie e-post automaatselt',
      companyEmail: 'Palun kasutage registreerimiseks oma ettevõtte e-posti aadressi',
      contactSupport: 'Võtke ühendust tugiteenusega, kui vajate registreerimisel abi'
    },
    b2bUsers: 'Ärikonto kasutajad:',
    registeredEmail: 'Registreeritud e-posti aadress',
    registeredPassword: 'Registreerimisel määratud parool',
    b2bCustomerRequired: 'See e-posti aadress ei ole registreeritud ärikliendina. Palun võtke esmalt ühendust müügiosakonnaga ärisuhte loomiseks.',
    b2bVerificationError: 'Ärikliendi staatust ei saa kontrollida. Palun võtke ühendust tugiteenusega.',
    // Password Reset
    passwordReset: 'Parooli lähtestamine',
    passwordResetDescription: 'Sisestage oma e-posti aadress ajutise parooli saamiseks',
    getTemporaryPassword: 'Saa ajutine parool',
    processing: 'Töötlemine...',
    passwordResetComplete: 'Parooli lähtestamine lõpetatud',
    temporaryPasswordGenerated: 'Ajutine parool on loodud',
    temporaryPassword: 'Ajutine parool',
    backToLogin: 'Tagasi sisselogimisse',
    securityNotice: 'Turvateade:',
    securityNotePoints: {
      keepSecret: 'Ärge jagage ajutist parooli teistega',
      changeAfterLogin: 'Vahetage kindlasti parool pärast sisselogimist',
      expires24Hours: 'Ajutine parool aegub 24 tunni pärast'
    },
    resetNote: 'Märkus:',
    resetNotePoints: {
      registeredEmail: 'Sisestage oma registreeritud e-posti aadress',
      passwordDisplayed: 'Ajutine parool kuvatakse ekraanil',
      changeRequired: 'Pärast sisselogimist on parooli vahetamine kohustuslik'
    },
    copied: 'Kopeeritud',
    copySuccessMessage: 'Ajutine parool on lõikelauale kopeeritud.',
    forgotPassword: 'Unustasite parooli?',
    // Password Reset Email Request
    sendResetLink: 'Saada lähtestuslink',
    sendingEmail: 'E-kirja saatmine...',
    emailSent: 'E-kiri saadetud',
    emailSentMessage: 'Kui see e-posti aadress on meie süsteemis olemas, saate peagi parooli lähtestamise lingi.',
    emailNotSent: 'E-kirja ei saadetud',
    emailSentInfo: 'Kontrollige oma postkasti ja rämpsposti kausta',
    checkEmail: 'Kontrolli e-posti',
    emailInstructions: 'Parooli lähtestamise juhised on saadetud',
    nextSteps: 'Järgmised sammud:',
    nextStepsList: {
      checkInbox: 'Kontrollige oma postkasti ja rämpsposti kausta',
      clickLink: 'Klõpsake e-kirjas olevat lähtestuslinki',
      linkExpires: 'Link aegub 24 tunni pärast',
      contactSupport: 'Võtke ühendust tugiteenusega, kui te ei saa e-kirja',
      rateLimitInfo: 'Piiratud 3 taotluseni tunnis'
    },
    // Password Reset Completion
    resetLinkSent: 'Lähtestuslink saadetud',
    resetSuccess: 'Parool edukalt lähtestatud',
    passwordUpdated: 'Parool uuendatud',
    passwordUpdateMessage: 'Teie parool on edukalt uuendatud. Nüüd saate oma uue parooliga sisse logida.',
    loginWithNewPassword: 'Logi sisse uue parooliga',
    // Reset Token Page
    resetToken: 'Lähtesta parool',
    invalidToken: 'Kehtetu lähtestamise tunnus',
    expiredToken: 'Lähtestamise tunnus on aegunud',
    tokenValid: 'Lähtestamise tunnus on kehtiv',
    newPassword: 'Uus parool',
    confirmNewPassword: 'Kinnita uus parool',
    updatePassword: 'Uuenda parool',
    updatingPassword: 'Parooli uuendamine...',
    passwordMismatch: 'Paroolid ei ühti',
    resetInstructions: 'Sisestage oma uus parool lähtestamise lõpetamiseks',
  },
  accountInfo: {
    title: 'Konto teave',
    loading: 'Konto teabe laadimine...',
    error: 'Viga',
    errorMessage: 'Konto teabe hankimine ebaõnnestus',
    back: 'Tagasi',
    basicInfo: 'Põhiteave',
    name: 'Nimi',
    email: 'E-posti aadress',
    contactId: 'Knitido kliendi ID',
    contactNumber: 'Kontakti number',
    noInfo: 'Teave puudub',
    companyInfo: 'Ettevõtte teave',
    company: 'Ettevõtte nimi',
    position: 'Ametikoht',
    vatId: 'KMKR number',
    billingAddress: 'Arveaadress',
    deliveryAddress: 'Tarneaadress',
    addressInfo: 'Aadressi teave',
    billingDescription: 'Aadress arvete ja lepingudokumentide jaoks',
    deliveryDescription: 'Standardne tarneaadress toodete saadetistele',
    sameAsBilling: '※ Sama mis arveaadress',
    sameAsDelivery: '※ Sama mis tarneaadress',
    companyName: 'Ettevõtte nimi',
    contactPerson: 'Kontaktisik',
    address: 'Aadress',
    phoneNumber: 'Telefoninumber',
    billingUsage: 'Kasutatakse arvete, lepingute ja muude oluliste dokumentide sihtkohana',
    deliveryUsage: 'Kasutatakse tellitud toodete standardse tarneaadressina',
    alsoUsedForDelivery: 'Kasutatakse ka tarne sihtkohana',
    accountType: 'Konto tüüp',
    addressId: 'Aadressi ID',
    // Address editing functionality
    edit: 'Muuda',
    editDeliveryAddress: 'Muuda tarneaadressi',
    editDeliveryDescription: 'Uuendage oma tarneaadressi teavet',
    newDeliveryAddress: 'Lisa uus tarneaadress',
    newDeliveryDescription: 'Sisestage uue tarneaadressi andmed',
    noDeliveryAddress: 'Tarneaadressi pole seadistatud',
    success: 'Õnnestus',
    addressUpdated: 'Tarneaadress edukalt uuendatud',
    updateError: 'Tarneaadressi uuendamine ebaõnnestus',
    requiredFields: 'Palun täitke kõik kohustuslikud väljad',
    firstName: 'Eesnimi',
    lastName: 'Perekonnanimi',
    streetAddress: 'Tänava aadress',
    streetAddress2: 'Tänava aadress 2',
    city: 'Linn',
    country: 'Riik',
    selectCountry: 'Valige riik',
    searchCountry: 'Otsi riiki...',
    noCountryFound: 'Riiki ei leitud.',
    postalCode: 'Postiindeks',
    companyNamePlaceholder: 'Sisestage ettevõtte nimi',
    firstNamePlaceholder: 'Eesnimi',
    lastNamePlaceholder: 'Perekonnanimi',
    streetAddressPlaceholder: 'Sisestage tänava aadress',
    streetAddress2Placeholder: 'Korter, sviit jne',
    cityPlaceholder: 'Sisestage linn',
    postalCodePlaceholder: 'Sisestage postiindeks',
    billingNotEditable: 'Arveaadressi ei saa muuta.',
    billingContactSupport: 'Muudatuste tegemiseks võtke ühendust tugiteenusega.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} tarneaadressi',
    noDeliveryAddresses: 'Ühtegi tarneaadressi ei ole registreeritud',
    defaultAddress: 'Vaikimisi',
    selectDeliveryAddress: 'Valige tarneaadress',
    addNewAddress: 'Lisa uus aadress',
    editAddress: 'Muuda aadressi',
    deleteAddress: 'Kustuta aadress',
    confirmDelete: 'Kinnita kustutamine',
    confirmDeleteMessage: 'Kas olete kindel, et soovite selle aadressi kustutada? Seda toimingut ei saa tagasi võtta.',
    addressAddedSuccess: 'Tarneaadress lisatud',
    addressDeletedSuccess: 'Tarneaadress kustutatud',
    deleteError: 'Tarneaadressi kustutamine ebaõnnestus',
    saving: 'Salvestamine...',
    cancel: 'Tühista',
    saveChanges: 'Salvesta muudatused',
    selectedDeliveryAddress: 'Valitud tarneaadress',
  },
  dashboard: {
    title: 'Äripartner',
    subtitle: 'Toodete tellimissüsteem',
    welcome: 'Tere tulemast,',
    welcomeMessage: 'Tere tulemast äripartneri tellimissüsteemi. Siin saate tellida tooteid.',
    productCatalog: 'Tootekataloog',
    productCatalogDesc: 'Sirvige ja tellige saadaolevaid tooteid',
    viewProducts: 'Vaata tooteid',
    orderHistory: 'Tellimuste ajalugu',
    orderHistoryDesc: 'Vaadake varasemaid tellimusi (varsti)',
    accountSettings: 'Konto seaded',
    accountSettingsDesc: 'Hallake konto teavet (varsti)',
    comingSoon: 'Varsti',
    infoTitle: 'Kasutamise kohta',
    orderingInfo: 'Toodete tellimine',
    orderingDesc: 'Valige kataloogist tooted ja määrake suurus ja värv. Saadaval on reaalajas laoinfo.',
    supportInfo: 'Tugi',
    supportDesc: 'Kui teil on küsimusi, võtke meiega ühendust.',
    viewOrderHistory: 'Vaata tellimuste ajalugu',
    viewOrders: 'Vaata tellimusi',
    accountInfo: 'Konto teave',
    accountInfoDesc: 'Vaadake oma konto teavet',
    viewDetails: 'Vaata üksikasju',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Esmaspäev-reede 9:00 - 15:00 CET',
    bulkImportDesc: 'Importige tellimusi Excel/CSV failidest',
    importOrders: 'Impordi tellimusi',
  },
  products: {
    title: 'Toodete nimekiri',
    subtitle: 'Äripartner',
    searchPlaceholder: 'Otsige toote nime või SKU järgi...',
    productId: 'Toote ID',
    addToCart: 'Lisa ostukorvi',
    selectVariation: 'Vali variant',
    price: 'Hind',
    priceNetNotice: 'Kõik hinnad on netohinnad',
    stock: 'Laoseis',
    color: 'Värv',
    newProducts: 'Uued Tooted',
    newProductBadge: 'UUS',
    size: 'Suurus',
    quantity: 'Kogus',
    total: 'Kokku',
    cart: 'Ostukorv',
    checkout: 'Vormista',
    csvMode: 'CSV kiirre¸iim',
    csvInfo: 'Tooteandmed pärinevad CSV andmetest',
    csvUploadDate: 'CSV üleslaadimise kuupäev:',
    stockNote: '※ Laoinfo saadakse tootevariantide valimisel',
    noProducts: 'Tooteid ei leitud',
    noProductsDesc: 'Muutke otsingukriteeriumeid või laadige üles CSV fail kiirema jõudluse saamiseks.',
    retry: 'Proovi uuesti',
    pagination: 'tooted',
    variations: 'variandid',
    stockFetchError: 'Laoinfo hankimise viga',
    stockFetchFailed: 'Laoinfo hankimine ebaõnnestus',
    stockFetchFailedDesc: 'Laoinfot ei saanud hankida. Kuvatakse CSV laoseis.',
    stockFetched: 'Laoinfo hangitud',
    totalStock: 'Laoseis kokku',
    noStockAll: 'Kõigil variantidel on null laoseisu',
    noStockData: 'Laoseisu andmeid ei tagastatud',
    stockFetchErrorDesc: 'Laoinfo hankimisel ilmnes viga',
    selectionError: 'Valiku viga',
    enterQuantity: 'Palun sisestage kogus',
    addedToCart: 'Lisatud ostukorvi',
    typesAdded: ' tooteliiki lisatud',
    addToCartError: 'Viga ostukorvi lisamisel',
    addToCartErrorDesc: 'Palun proovige uuesti',
    loadingStock: 'Laoinfo laadimine',
    csvDataInfo: 'Kuvatakse CSV andmete teave (mitte tegelikud laoseisu tasemed)',
    invalidDataFormat: 'Tooteandmete vormingu on kehtetu',
    loadFailed: 'Tooteandmete laadimine ebaõnnestus',
    csvUploadComplete: 'CSV üleslaadimine lõpetatud',
    csvLoadedDesc: ' tooteandmed laaditud. Laoinfo hangitakse toodete valimisel.',
    searchTitle: 'Toodete otsing',
    loadingProducts: 'Tooteandmete laadimine',
    noProductsCsv: 'CSV andmetes tooteid ei leitud. Palun muutke otsingukriteeriumeid.',
    paginationDisplay: ' kuvatud',
    previous: 'Eelmine',
    next: 'Järgmine',
    selectionSummary: 'Valiku kokkuvõte',
    selectedQuantity: 'Valitud kogus',
    items: ' tooted',
    viewDetails: 'Vaata üksikasju',
    productImage: 'Toote pilt',
    correspondingVariations: 'Vastavad variandid',
    clickToEnlarge: 'Klõpsake suurendamiseks',
    productIdLabel: 'Toote ID',
    colorLabel: 'Värv',
    filterByCategory: 'Filtreeri kategooria järgi',
    allProducts: 'Kõik tooted',
    applyFilters: 'Rakenda filtrid',
    clearFilters: 'Tühjenda filtrid',
    filters: 'Filtrid',
    clearAll: 'Tühjenda kõik',
  },
  categories: {
    category_21: 'Varbasokkid',
    category_23: 'Kategoriseerimata',
    category_24: 'Kehariided',
    category_29: 'B2B tooted',
  },
  productDetail: {
    title: 'Toote üksikasjad',
    backToProducts: 'Tagasi toodete juurde',
    productNotFound: 'Toodet ei leitud',
    productNotFoundDesc: 'Määratud toodet ei eksisteeri või on kustutatud.',
    loading: 'Toote laadimine...',
    imageLoadError: 'Piltide laadimine ebaõnnestus',
    noImages: 'Pilte pole saadaval',
    productDescription: 'Toote kirjeldus',
    colors: 'Värvid',
    sizes: 'Suurused',
    colorCount: 'värvi',
    sizeCount: 'suurust',
    variationCount: 'varianti',
    selectVariation: 'Vali variandid',
    descriptionLanguageNote: '※ Tootekirjeldused on saadaval ainult inglise või saksa keeles',
  },
  colors: {
    schwarz: 'Must',
    weiß: 'Valge',
    grau: 'Hall',
    rot: 'Punane',
    blau: 'Sinine',
    grün: 'Roheline',
    gelb: 'Kollane',
    rosa: 'Roosa',
    lila: 'Lilla',
    braun: 'Pruun',
    orange: 'Oranž',
    beige: 'Beež',
    navy: 'Tumesinine',
    dunkelblau: 'Tumesinine',
    hellblau: 'Helesinine',
    dunkelgrau: 'Tumehall',
    hellgrau: 'Helehall',
    bordeaux: 'Bordoo',
    türkis: 'Türkiis',
    khaki: 'Khaki',
    mint: 'Piparmünt',
    violett: 'Violetne',
    anthrazit: 'Antratsiidhall',
    blaugrau: 'Sinakashall',
    burgunderrot: 'Burgundia punane',
    elfenbein: 'Elevandiluu',
    karminrot: 'Karmiinpunane',
    neongrün: 'Neoonroheline',
    gelbgrün: 'Kollakasroheline',
    pistazie: 'Pistaatsia',
    // Ingliskeelsed värvinimed (kasutatakse Product ID 237 jne)
    blue: 'Sinine',
    ivory: 'Elevandiluuvärv',
    green: 'Roheline',
    gold: 'Kuldne',
    red: 'Punane',
  },
  checkout: {
    title: 'Vormistamine',
    cartReview: 'Tellimuse ülevaade',
    orderSummary: 'Tellimuse kokkuvõte',
    shippingInfo: 'Tarneteave',
    billingInfo: 'Arveldusinfo',
    orderNotes: 'Tellimuse märkused',
    orderNotesPlaceholder: 'Erisoovid või märkused...',
    contactPerson: 'Kontaktisik',
    phoneNumber: 'Telefoninumber',
    email: 'E-posti aadress',
    company: 'Ettevõte',
    address: 'Aadress',
    city: 'Linn',
    postalCode: 'Postiindeks',
    country: 'Riik',
    deliveryDate: 'Tarnekuupäev',
    urgentDelivery: 'Ekspresstarne (3-5 tööpäeva)',
    standardDelivery: 'Standardtarne (7-10 tööpäeva)',
    placeOrder: 'Esita tellimus',
    backToCart: 'Tagasi tootevalikusse',
    requiredField: 'Kohustuslik väli',
    orderTotal: 'Tellimuse summa',
    subtotal: 'Vahesumma',
    priceNetNotice: 'Kõik hinnad on netohinnad',
    stockReservationNotice: 'Laoreserveerimine tehakse pärast tellimuse kinnitamist.',
    stockCheckError: 'Laoseisu kontrolli viga',
    stockCheckErrorDesc: 'Laoseisu kontrollimisel ilmnes viga. Palun proovige uuesti.',
    shipping: 'Tarne',
    shippingCost: 'Tarnekulud',
    tax: 'Maks',
    orderSuccess: 'Tellimus õnnestus',
    orderSuccessMessage: 'Teie tellimus on edukalt esitatud. Tellimuse number: {orderNumber}',
    orderNumber: 'Tellimuse number',
    thankYou: 'Täname teid tellimuse eest!',
    orderConfirmation: 'Teie tellimus on edukalt esitatud.',
    orderProcessing: 'Pärast meie meeskonna ülevaatust saadame teile e-postiga tellimuse kinnituse.',
    orderProcessingMessage: 'Teie tellimus on edukalt esitatud. Pärast meie meeskonna ülevaatust saadame teile e-postiga tellimuse kinnituse.',
    continueShopping: 'Jätka ostlemist',
    emptyCart: 'Teie ostukorv on tühi',
    emptyCartMessage: 'Palun lisage tooted oma ostukorvi jätkamiseks',
    stockWarning: 'Laoseisu hoiatus',
    stockWarningDesc: 'Mõnedel toodetel pole piisavalt laoseisu. Palun kohandage koguseid.',
    stockError: 'Laoseisu viga',
    stockErrorDesc: 'On tooteid ebapiisava laoseisuga. Palun kohandage koguseid.',
    refreshStock: 'Värskenda laoseisu',
    stockUpdated: 'Laoseis uuendatud',
    stockUpdatedDesc: 'Laoseis on uuendatud - {changed} toodet muudetud',
    stockCheckDesc: 'Võrdlustulemused laoseisuga kuvatakse',
    stockOk: 'Laoseis OK',
    stockShortage: 'Laoseisu puudus',
    requestedQty: 'Taotletud kogus',
    currentStock: 'Praegune laoseis',
    stockShortageMsg: 'Ebapiisav laoseis. Palun kohandage kogust.',
    stockIssueWarning: 'Tellimust ei saa kinnitada laoseisu probleemide tõttu.',
    stockDataMissing: 'Laoseisu andmeid hangitakse. Palun oodake hetk.',
    outOfStock: 'Laost otsas.',
    maxAvailable: 'Maksimaalselt',
    autoRestored: 'Ostukorv taastatud',
    autoRestoredDesc: 'Teie viimase seansi esemed on taastatud',
    maxQuantityReached: 'Maksimaalne laoseis saavutatud.',
    // ERP Contact Search
    contactSearch: 'Kliendi kontakti otsing',
    contactSearchDesc: 'Sisestage tellija e-posti aadress kontaktteabe hankimiseks',
    emailAddress: 'E-posti aadress',
    searchButton: 'Otsi',
    searching: 'Otsimine',
    contactFound: 'Kontakt leitud',
    contactNotFound: 'Kontakti ei leitud',
    contactId: 'Knitido kliendi ID',
    companyName: 'Ettevõte',
    contactPersonLabel: 'Kontaktisik',
    addressesFound: 'Leitud aadressid',
    addressType: 'Tüüp',
    addressBilling: 'Arveaadress',
    addressDelivery: 'Tarneaadress',
    vatSourceCompany: 'Ettevõtte info',
    vatSourceBilling: 'Arve',
    vatSourceDelivery: 'Tarne',
    addressOther: 'Muu',
    addressDetails: 'Aadress',
    loadingAddresses: 'Aadressi teabe laadimine...',
    addressRetrieved: 'Aadressi teave hangitud',
    addressNotFound: 'Aadressi teavet ei leitud',
    addressNotFoundDesc: 'Registreeritud aadressi teavet pole. Palun sisestage käsitsi.',
    addressError: 'Aadressi hankimise viga',
    addressErrorDesc: 'Aadressi teabe hankimine ebaõnnestus.',
    contactNotConfirmed: 'Kliendi kontakt pole kinnitatud',
    contactNotConfirmedDesc: 'Palun sisestage e-posti aadress ja otsige kontakti.',
    searchContact: 'Otsi kontakti',
    inputError: 'Sisestusviga',
    inputErrorDesc: 'Tarneteave on puudulik. Palun kontrollige.',
    processing: 'Töötlemine...',
    erpContactSearch: 'Kliendi kontakti otsing',
    contactSearchError: 'E-posti aadress ei vasta ühelegi registreeritud kontaktile.',
    // Product Images Toggle
    showProductImages: 'Näita toodete pilte',
    showProductImagesDesc: 'Kuva toodete pildid parema ülevaate saamiseks (võib suurendada laadimisaega)',
    // System Registration Info
    systemRegistrationInfo: 'Teie kliendi teave',
    editShippingAddress: 'Muuda tarneaadressi',
    systemRegistrationInfoDesc: 'Teie registreeritud äriandmed. Palun võtke ühendust oma esindajaga, kui peate uuendama arveaadressi andmeid.',
    // Order Summary
    regularPrice: 'Tavaline hulgihind',
    offeredPrice: 'Pakutud hind',
    discount: 'Allahindlus',
    b2bCustomer: 'B2B klient',
    pattern: 'Muster',
    specialPriceApplied: 'Rakendatud erihind',
    customerClassification: 'Kliendi klassifikatsioon',
    paymentCondition: 'Maksetingimused',
    invoice: 'Arve (NET 30)',
    prepayment: 'Ettemaks',
    paymentMethod: 'Makseviis',
    invoicePayment: 'Arve makse',
    estimatedSubtotal: 'Hinnanguline vahesumma',
    estimatedTotal: 'Hinnanguline kogusumma',
    orderSummaryDisclaimer: 'Siin näidatud hinnad on hinnangulised. Kui oleme teie tellimuse saanud, vaatame selle üle ja saadame teile e-postiga siduva tellimuse kinnituse lõplike hindade, tarnekulude ja maksudega.',
    searchError: 'Otsingu viga',
    searchErrorDesc: 'Kontakti otsimisel ilmnes viga.',
    confirmDeleteItem: 'Eemalda toode',
    itemDeleted: 'Toode eemaldatud',
    confirmDeleteItemDesc: 'Kas soovite kindlasti selle toote oma ostukorvist eemaldada?',
    deleteConfirm: 'Eemalda',
    contactNotes: 'Kontakti märkused',
    contactNotesDesc: 'Kas teil on küsimusi või erisoove? Palun andke meile teada (valikuline)',
    contactNotesLabel: 'Sõnum',
    contactNotesPlaceholder: 'nt: Toote küsimused, erinõuded jne',
    characters: 'tähemärki',
    contactIdLabel: 'Knitido kliendi ID',
    companyLabel: 'Ettevõte',
    personLabel: 'Kontaktisik',
    emailLabel: 'E-post',
    addressTypeLabel: 'Tüüp',
    destinationLabel: 'Sihtkoht',
    // Shipping Form
    shippingTitle: 'Tarneteave',
    shippingDesc: 'Sisestage toodete tarneaadress',
    companyRequired: 'Ettevõte *',
    contactPersonRequired: 'Kontaktisik *',
    emailRequired: 'E-posti aadress *',
    phoneRequired: 'Telefoninumber *',
    addressRequired: 'Aadress 1 *',
    address2: 'Aadress 2 (Hoone/Tuba)',
    postalCodeRequired: 'Postiindeks *',
    cityRequired: 'Linn *',
    countryRequired: 'Riik *',
    selectCountry: 'Vali riik',
    shippingMethodRequired: 'Tarneviis *',
    selectShippingMethod: 'Vali tarneviis',
    urgentDeliveryOption: 'Ekspresstarne (lisatasu)',
    deliveryNotes: 'Tarne märkused',
    deliveryNotesPlaceholder: 'Sisestage tarneaja eelistused või muud soovid',
    standardShipping: 'Standardtarne (3-5 tööpäeva)',
    expressShipping: 'Ekspresstarne (1-2 tööpäeva)',
    overnightShipping: 'Öine tarne',
    germany: 'Saksamaa',
    austria: 'Austria',
    switzerland: 'Šveits',
    japan: 'Jaapan',
    shippingAddressLabel: 'Tarneaadress',
    changeDeliveryAddress: 'Muuda tarneaadressi',
    selectDeliveryAddress: 'Vali tarneaadress',
    // Shipping Cost Details
    freeShipping: 'Tasuta tarne',
    shippingError: 'Viga',
    shippingZone: 'Tarnetsoon',
    remainingForFreeShipping: '{amount} tasuta tarneni',
    moreForFreeShipping: 'veel tasuta tarneni',
    freeShippingProgress: 'Tasuta tarne alates',
    andAboveFreeShipping: 'ja rohkem tasuta tarneks',
    freeShippingAchieved: 'Tasuta tarne rakendatud',
    threshold: 'ja rohkem',
    nextShippingTier: 'Järgmine tarneallahindlus',
    moreForDiscount: 'veel',
    shippingSavings: 'tarnekulude kokkuhoiuks',
    orderAmountThreshold: 'ja rohkem',
    specialRegionNotice: 'Rakendatud eritarnetsoon',
    defaultShippingApplied: 'Rakendatud standardsed tarnetasud',
    requestedQuantity: 'Taotletud kogus',
    availableQuantity: 'Saadaval kogus',
    orderSubmitError: 'Tellimuse viga',
    orderSubmitErrorDesc: 'Tellimuse esitamine ebaõnnestus',
    upload: {
      title: 'Impordi Excel/CSV tellimus',
      description: 'Laadige üles Excel või CSV fail oma tellimuse andmetega',
      dragDropOrClick: 'Lohistage fail siia või klõpsake valimiseks',
      dropHere: 'Kukutage fail siia',
      supportedFormats: 'Toetatud vormingud: Excel (.xlsx, .xls) ja CSV (.csv)',
      maxSize: 'Maksimaalne faili suurus: {size} MB',
      processFile: 'Töötle faili',
      processing: 'Faili töötlemine...',
      ready: 'Fail on eelvaateks valmis',
      readyDescription: 'Teie fail on edukalt töödeldud ja on ülevaatamiseks valmis.',
      preview: 'Näita eelvaadet',
      errors: {
        fileTooLarge: 'Fail on liiga suur. Maksimaalne suurus: {size} MB',
        invalidFileType: 'Kehtetu failitüüp. Palun laadige üles Excel või CSV fail',
        uploadFailed: 'Viga faili üleslaadimisel',
      },
    },
    // Loading messages
    loadingPage: 'Lehe laadimine...',
    loadingStock: 'Toodete laoseisu kontrollimine...',
    loadingAccount: 'Konto teabe laadimine...',
    loadingError: 'Ilmnes viga...',
    loadingData: 'Andmete laadimine',
    // Toast messages
    addressRetrievedTitle: 'Aadressi teave hangitud',
    addressSetAsDelivery: ' aadress määratud tarne sihtkohaks.',
    contactFoundDesc: ' tuvastati.'
  },
  orderHistory: {
    title: 'Tellimuste ajalugu',
    searchPlaceholder: 'Otsige tellimuse numbri või SKU järgi...',
    noOrders: 'Tellimusi ei leitud',
    noOrdersFound: 'Vastavaid tellimusi ei leitud',
    startShopping: 'Vaata tooteid',
    orderItems: 'Tellimuse tooted',
    viewDetails: 'Üksikasjad',
    reorder: 'Telli uuesti',
    orderDate: 'Tellimuse kuupäev',
    orderStatus: 'Staatus',
    orderTotal: 'Tellimuse summa',
    // Status translations
    statusPending: 'Ootel makse',
    statusProcessing: 'Töötlemisel',
    statusConfirmed: 'Kinnitatud',
    statusShipped: 'Saadetud',
    statusDelivered: 'Kohale toimetatud',
    statusCancelled: 'Tühistatud',
    statusReturned: 'Tagastatud',
    statusRefunded: 'Raha tagastatud',
    statusWarranty: 'Garantii',
    statusExchanged: 'Vahetatud',
    statusRepair: 'Remont',
    statusUnknown: 'Teadmata',
    statusIncomplete: 'Mittetäielik',
    statusWaitingPayment: 'Ootab makset',
    statusInPreparation: 'Ettevalmistamisel',
    statusClearedShipping: 'Lubatud saatmiseks',
    statusBeingShipped: 'Saadetakse',
    statusOutgoingBooked: 'Väljuv broneeritud',
    statusReturn: 'Tagastus',
    // Additional UI elements
    itemCount: 'toodet',
    itemCountSingular: 'toode',
    refreshButton: 'Värskenda',
    errorFetchingOrders: 'Tellimuste ajaloo hankimine ebaõnnestus',
    // Payment status features
    paymentStatus: 'Makse staatus',
    markAsPaid: 'Märgi makstuks',
    unmarkAsPaid: 'Eemalda makse märge',
    paidOn: 'Makstud',
    paymentMarked: 'Makstud',
    notPaid: 'Maksmata',
    paymentMarkedSuccess: 'Edukalt märgitud makstuks',
    paymentUnmarkedSuccess: 'Makse märge eemaldatud',
    paymentUpdateError: 'Makse staatuse uuendamine ebaõnnestus',
    // Payment date dialog
    paymentDateTitle: 'Sisesta makse teave',
    paymentDateDescription: 'Sisestage makse teave tellimuse {orderNumber} jaoks',
    paymentDateLabel: 'Makse kuupäev',
    selectDate: 'Vali kuupäev',
    paymentDateHelp: 'Valige kuupäev, millal pangaülekanne tehti',
    paymentMethodLabel: 'Makseviis',
    bankTransfer: 'Pangaülekanne',
    invoice: 'Arve',
    otherPayment: 'Muu',
    paymentReferenceLabel: 'Ülekande nimi / Viitenumber',
    paymentReferencePlaceholder: 'nt Jaan Tamm, Ülekanne #12345',
    paymentReferenceHelp: 'Sisestage teave, mis aitab sobitada pangaväljavõtetega',
    notesLabel: 'Märkused',
    notesPlaceholder: 'Sisestage täiendav makse teave',
    // Filter options
    filterByPaymentStatus: 'Filtreeri makse staatuse järgi',
    allOrders: 'Kõik tellimused',
    paidOrders: 'Makstud',
    unpaidOrders: 'Maksmata',
    // Sorting options
    sortBy: 'Sorteeri',
    sortByDate: 'Tellimuse kuupäeva järgi',
    sortByPaymentDate: 'Makse kuupäeva järgi',
    sortByAmount: 'Summa järgi',
    sortByStatus: 'Staatuse järgi',
  },
  orderDetails: {
    title: 'Tellimuse üksikasjad',
    notFound: 'Tellimust ei leitud',
    backToHistory: 'Tagasi tellimuste ajalukku',
    orderDate: 'Tellimuse kuupäev',
    orderItems: 'Tellimuse tooted',
    deliveryStatus: 'Tarne staatus',
    estimatedDelivery: 'Eeldatav tarne',
    deliveredOn: 'Kohale toimetatud',
    downloadInvoice: 'Laadi arve alla',
    statusDelivered: 'Kohale toimetatud',
    statusShipped: 'Saadetud',
    statusConfirmed: 'Kinnitatud',
    statusCancelled: 'Tühistatud',
    errorFetchingDetails: 'Tellimuse üksikasjade hankimine ebaõnnestus',
  },
  company: {
    name: 'Äripartner',
    tagline: 'Äripartneri süsteem',
    copyright: '© 2025 Äripartneri süsteem. Kõik õigused kaitstud.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-post',
    countries: {
      DE: 'Saksamaa',
      AT: 'Austria',
      CH: 'Šveits',
      FR: 'Prantsusmaa',
      IT: 'Itaalia',
      ES: 'Hispaania',
      NL: 'Holland',
      BE: 'Belgia',
      PL: 'Poola',
      SE: 'Rootsi',
      NO: 'Norra',
      FI: 'Soome',
      DK: 'Taani',
      LT: 'Leedu',
      LV: 'Läti',
      EE: 'Eesti',
    },
  },
  cart: {
    newCart: 'Uus ostukorv',
    currentCart: 'Praegune ostukorv',
    modified: 'muudetud',
    lastSaved: 'Viimati salvestatud',
    unsavedChanges: 'salvestamata muudatused',
    saveCart: 'Salvesta ostukorv',
    loadCart: 'Laadi ostukorv',
    deleteCart: 'Kustuta ostukorv',
    startNewCart: 'Alusta uut ostukorvi',
    savedCarts: 'Salvestatud ostukorvid',
    cartSaved: 'Ostukorv salvestatud',
    cartDeleted: 'Ostukorv kustutatud',
    confirmDeleteCart: 'Kustutada ostukorv?\n\nSeda toimingut ei saa tagasi võtta.',
    confirmSwitchCart: 'Praegusel ostukorvil on salvestamata muudatusi.\n\nTeise ostukorvi laadimisel praegused muudatused kaovad.\n\nJätkata?',
    confirmSwitchCartTitle: 'Vaheta ostukorvi',
    confirmNewCart: 'Praegusel ostukorvil on salvestamata muudatusi.\n\nUue ostukorvi alustamisel praegused muudatused kaovad.\n\nJätkata?',
    confirmNewCartTitle: 'Alusta uut ostukorvi',
    confirmClearCart: 'Tühjendada ostukorv?\n\n{count} toodet eemaldatakse.\n\nSeda toimingut ei saa tagasi võtta.',
    confirmClearCartTitle: 'Tühjenda ostukorv',
    autoSaved: 'Automaatselt salvestatud',
    itemsWillBeRemoved: 'toodet eemaldatakse',
    changesWillBeLost: 'muudatused kaovad',
    continueQuestion: 'Jätkata?',
    cartStatus: 'Ostukorvi staatus',
    cartName: 'Ostukorvi nimi',
    cartNamePlaceholder: 'nt: Kuu lõpu tellimus',
    cartNameRequired: 'Palun sisestage ostukorvi nimi',
    saveCartDescription: 'Andke praegusele ostukorvile nimi ja salvestage see. Saate selle hiljem laadida.',
    cancelCart: 'Tühista ostukorv',
    proceedToCheckout: 'Mine vormistamisele',
    emptyCart: 'Ostukorv on tühi',
    erpDown: 'Tellimussüsteem on maas. Palun proovige hiljem uuesti.',
    erpDegraded: 'Süsteem on praegu ebastabiilne. Tellimused võivad ebaõnnistuda.',
    erpDownSaveHint: 'Salvestage oma ostukorv ja tellige pärast süsteemi taastumist.',
    erpSaveCart: 'Salvesta ostukorv',
  },
  nav: {
    dashboard: 'Töölaud',
    products: 'Tooted',
    orderHistory: 'Tellimuste ajalugu',
    account: 'Konto teave',
    bulkImport: 'Hulgiimport',
  },
  settings: {
    selectLanguage: 'Valige keel',
    languagePreferenceSaved: 'Teie eelistus salvestatakse teie kontole tulevaste külastuste jaoks.',
  },
  reorder: {
    allItemsAdded: '{count} toodet lisatud ostukorvi',
    partialSuccess: '{added} toodet lisatud. {failed} toodet ei saanud lisada',
    allItemsFailed: 'Toodete lisamine ostukorvi ebaõnnestus',
    error: 'Uuesti tellimise ajal ilmnes viga',
    itemDiscontinued: '{name} ({color}/{size}) on lõpetatud',
    itemOutOfStock: '{name} ({color}/{size}) on laost otsas',
    partialStock: '{name} ({color}/{size}) ainult {available} saadaval',
    confirmReorder: 'Kinnita uuesti tellimine',
    confirmReorderMessage: 'Lisada selle tellimuse tooted oma ostukorvi?',
    addingToCart: 'Lisamine ostukorvi...',
    checkingStock: 'Laoseisu kontrollimine...',
    checkoutTitle: 'Tooted lisatud ostukorvi',
    checkoutDescription: '{count} toodet on lisatud teie ostukorvi. Kas soovite minna vormistamisele?',
  },
  bulkImport: {
    instructions: 'Kuidas tellimusi importida',
    step1: 'Laadige alla tellimuse mallifail',
    step2: 'Täitke oma tellimuse andmed SKU ja kogusega',
    step3: 'Salvestage Excel (.xlsx) või CSV failina',
    step4: 'Laadige fail üles kasutades allolevat vormi',
    step5: 'Vaadake üle ja kinnitage oma tellimus',
    downloadTemplate: 'Laadi mall alla',
    downloadExcelTemplate: 'Laadi Excel mall alla',
    downloadCsvTemplate: 'Laadi CSV mall alla',
    formatGuide: 'Faili vormingu juhend',
    requiredColumns: 'Kohustuslikud veerud',
    skuDescription: 'Toote SKU kood',
    quantityDescription: 'Tellimuse kogus (positiivne täisarv)',
    optionalColumns: 'Valikulised veerud',
    notesDescription: 'Sisemised märkused (nt PO number, viide) - ainult teie kirjetele',
    formatNote: 'Esimene rida peaks sisaldama veeru päiseid. Andmed algavad teisest reast.',
    parseSuccess: 'Edukalt analüüsitud {count} toodet failist',
    parseError: 'Analüüsimise viga',
    validationError: 'Valideerimise vead',
    validationErrorGuidance: 'Palun klõpsake nupul „{showPreviewButton}“, et vaadata üksikasju.',
    warnings: 'Hoiatused',
    itemsParsed: 'Edukalt analüüsitud {count} toodet:',
    andMore: '...ja veel {count} toodet',
    validationSummary: 'Valideerimise kokkuvõte',
    duplicateSKUs: 'Leitud duplikaat SKU-d',
    skuFormat: 'SKU peab sisaldama ainult tähti, numbreid ja sidekriipse',
    quantityRange: 'Kogus peab olema vahemikus 1 kuni 9999',
    maxRows: 'Maksimaalselt 1000 rida lubatud',
    rowsSkipped: '{count} rida jäeti vahele vigade tõttu',
    previewTitle: 'Tellimuse eelvaade',
    previewDescription: 'Vaadake üle ja muutke oma tellimuse andmeid enne jätkamist',
    proceedToCart: 'Lisa ostukorvi',
    // File parsing messages
    fileEmpty: 'Fail on tühi või ei sisalda andmeid',
    fileTooManyRows: 'Fail sisaldab liiga palju ridu ({current}). Maksimaalselt lubatud: {max}',
    invalidRowFormat: 'Kehtetu rea formaat',
    missingColumns: 'Puuduvad kohustuslikud veerud (SKU ja Kogus)',
    missingSku: 'Puudub SKU',
    invalidSkuFormat: 'Kehtetu SKU formaat: "{sku}" (peab vastama mustrile: {pattern})',
    skuTooLong: 'SKU liiga pikk: "{sku}" (maksimaalselt 50 tähemärki)',
    invalidQuantity: 'Kehtetu kogus: "{quantity}" pole number',
    quantityTooLow: 'Kogus liiga väike: {quantity} (miinimum: {min})',
    quantityTooHigh: 'Kogus liiga suur: {quantity} (maksimum: {max})',
    notesRequired: 'Märkuste väli on kohustuslik',
    noValidData: 'Kehtivaid andmeid ei leitud. Palun kontrollige oma faili vormingut.',
    row: 'Rida {row}: {errors}',
    rowErrors: '...ja veel {count} viga',
    duplicateSkuInRows: 'Duplikaat SKU "{sku}" leitud ridadel: {rows}',
    quantityExceedsMax: 'Rida {row}: Kogus {quantity} ületab maksimaalset lubatud ({max})',
    quantityBelowMin: 'Rida {row}: Kogus {quantity} on alla miinimumi ({min})',
    // Validation messages
    unsupportedFileFormat: 'Toetamata failivorming. Palun laadige üles CSV või Excel fail.',
    csvParsingErrors: 'CSV analüüsimisel ilmnesid vead',
    failedToParseFile: 'Faili analüüsimine ebaõnnestus',
    failedToParseExcel: 'Excel faili analüüsimine ebaõnnestus',
    failedToReadFile: 'Faili lugemine ebaõnnestus',
    unknownError: 'Ilmnes teadmata viga',
    totalRows: 'Ridu kokku',
    valid: 'Kehtiv',
    invalid: 'Kehtetu',
    skipped: 'Vahele jäetud',
    // SKU validation
    skuValidationError: 'SKU valideerimise viga',
    skuValidationFailed: 'SKU-de valideerimine ebaõnnestus. Võite siiski jätkata, kuid mõned tooted ei pruugi olla saadaval.',
    skuNotFound: 'SKU-d ei leitud andmebaasist',
    skusNotFound: '{count} SKU-d ei leitud andmebaasist',
    itemsHaveInsufficientStock: '{count} tootel on ebapiisav laoseis',
    validatingSKUs: 'Toodete kontrollimine...',
    unvalidatedChanges: 'Teil on valideerimata muudatusi. Palun valideerige uuesti enne ostukorvi lisamist.',
    revalidate: 'Valideeri uuesti',
    validating: 'Valideerimine...',
    validationSuccess: 'Kõik tooted on kehtivad',
    validationComplete: 'Valideerimine lõpetatud',
    validationResultSummary: '{errors} viga, {warnings} hoiatust leitud',
    // Table headers
    actions: 'Toimingud',
    notes: 'Märkused',
    // Status filter
    all: 'Kõik',
    hasErrors: 'Vigadega',
    // Selection summary
    selected: 'valitud',
    errors: 'vead',
    // Pagination
    page: 'Leht {current}/{total}',
    previous: 'Eelmine',
    next: 'Järgmine',
    noResults: 'Tulemusi pole.',
    // Cart integration
    noValidItems: 'Kehtivaid tooteid pole',
    allItemsHaveErrors: 'Kõigil toodetel on valideerimise vead. Palun parandage need enne jätkamist.',
    dataLoadingError: 'Andmete laadimise viga',
    failedToLoadProductData: 'Tooteandmete laadimine ebaõnnestus. Palun proovige uuesti.',
    itemsAddedToCart: '{count} toodet lisatud ostukorvi',
    itemsAddedMessage: 'Lisatud {count} toodet ostukorvi',
    someSkusNotFound: '{count} SKU-d ei leitud.',
    noItemsAdded: 'Tooteid ei lisatud',
    couldNotFindProducts: 'Ei leitud ühtegi toodet, mis vastaks SKU-dele.',
    errorAddingToCart: 'Viga',
    failedToAddToCart: 'Toodete lisamine ostukorvi ebaõnnestus. Palun proovige uuesti.',
    addingToCart: 'Lisamine ostukorvi...',
    // File info
    fileSelected: '{name} valitud töötlemiseks',
    fileSize: '{size} baiti',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Malli allalaadimine',
    templateWillBeImplemented: 'Malli allalaadimine rakendatakse 7. faasis',
    // Additional validation
    validationFailed: 'Valideerimine ebaõnnestus',
    // Template download
    templateDownloaded: 'Mall edukalt alla laaditud',
    templateDownloadError: 'Malli allalaadimine ebaõnnestus',
    // Template content
    sheetName: 'Hulgitellimus',
    instructionsSheetName: 'Juhised',
    columnDescriptions: 'Veergude kirjeldused:',
    columnHeader: 'Veerg',
    columnRequired: 'Kohustuslik',
    columnOptional: 'Valikuline',
    columnDescription: 'Kirjeldus',
    templateNotes: 'Märkused:',
    templateNote1: 'Esimene rida peab sisaldama veeru päiseid täpselt nagu näidatud',
    templateNote2: 'Andmed algavad 2. reast',
    templateNote3: 'SKU peab vastama süsteemis olevatele tootekoodidele',
    templateNote4: 'Kogus peab olema positiivne täisarv vahemikus 1 kuni 9999',
    templateNote5: 'Maksimaalselt 1000 rida faili kohta lubatud',
    templateNote6: 'Salvestage .xlsx või .csv formaadis',
    stockAvailabilityWarning: 'Tegelik laoseis kontrollitakse järgmisel kassalehel.',
    outOfStock: 'Otsas',
    insufficientStock: 'Ebapiisav laovaru: {available} saadaval, {requested} tellitud',
  },
  orderExport: {
    export: 'Ekspordi tellimus',
    exportOrder: 'Ekspordi tellimuse andmed',
    exportAsCSV: 'Ekspordi CSV-na',
    exportAsExcel: 'Ekspordi Excelina',
    exportForReorder: 'Ekspordi hulgiimpordi jaoks',
    detailed: 'Täielikud üksikasjad',
    simpleFormat: 'Impordi formaat',
  },
};